import Staff from "@/entities/staff";
import ApiClient from "./client";
import StaffGateway from "@/usecases/gateways/staff-gateway";

export interface ListStaffQuery {
  family?: string | number;
  serviceTaskTypeId?: string;
  invited?: boolean;
  isGetStaffAll?: number;
  hasRole?: boolean;
}

export default class StaffApi implements StaffGateway {
  public constructor(private client: ApiClient) {}

  public async save(staff: Staff) {
    const d = new FormData();
    d.append("id", String(staff.id));
    d.append("officeId", String(staff.officeId));
    d.append("name", staff.name);
    d.append("isHiddenInfo", String(staff.isHiddenInfo));
    d.append("tel", staff.tel);
    d.append("mail", staff.email);
    d.append("roleId", String(staff.roleId));
    staff.workTypeIds.forEach(id => {
      d.append("workTypeIds[]", String(id));
    });
    d.append("scheduleNotification", staff.scheduleNotification ? "1" : "0");
    d.append(
      "canModifyAssignedTasks",
      staff.canModifyAssignedTasks ? "1" : "0"
    );
    d.append(
      "canViewAllUninvitedProjects",
      staff.canViewAllUninvitedProjects ? "1" : "0"
    );
    const res = await this.client.post("save_staff.php", d);
    return { ...staff, id: res.staffId };
  }

  public async get(id: number) {
    const staffs = await this.getAll({ isGetStaffAll: 1 });
    return staffs.find(s => s.id === id);
  }

  public async getAll(options: ListStaffQuery = {}): Promise<Staff[]> {
    const data = await this.client.get("get_all_staffs.php", {
      family: options.family,
      service_task_type: options.serviceTaskTypeId,
      invited: options.invited,
      isGetStaffAll: options.isGetStaffAll,
      hasRole: options.hasRole
    });
    return data.staffList.map(toStaff);
  }

  public async getOurs() {
    const data = await this.client.get("get_all_staffs.php", {
      family: 1,
      invited: false,
      isGetStaffAll: 1
    });
    return data.staffList.map(toStaff);
  }
}

function toStaff(s: any) {
  return new Staff({ ...s, id: s.staffId, email: s.mail });
}
